export default __webpack_public_path__ + "static/media/top123-meter.e5700817.svg";